<ion-content
  class="change-po_content"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
      : 'ion-content-modal-desktop'
  "
  scroll-y="true"
>
  <ion-item>
    <ion-input
      id="po-number-input"
      data-cy="po-number-input"
      name="poNumber"
      placeholder="Enter PO #"
      [appRegexInputValidator]="poRegex"
      maxlength="20"
      [(ngModel)]="poNumber"
      #poNumberInput
      [attr.autofocus]="!isIos ? true : null"
      inputmode="text"
      enterkeyhint="done"
    ></ion-input>
  </ion-item>

  <ng-container *ngIf="!isPoDisabledForVPTAndPunchOut">
    <ion-item *appShowSplit="[defaultPoFeatureFlag]" class="toggle-container">
      <ion-label class="toggle-label">{{
        'i18n.orderPage.saveDefaultPo' | translate
      }}</ion-label>
      <ion-toggle
        [(ngModel)]="saveDefaultPo"
        class="toggle-control"
        data-cy="save-default-po-edit-modal"
      ></ion-toggle>
    </ion-item>
  </ng-container>
</ion-content>

<ion-footer
  class="ion-footer-modal"
  [class.ion-footer-modal-desktop]="platform === 'desktop'"
>
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="update-submit-po-number-btn"
        class="usf-fill-green-dsktp-tblt-modal-button"
        data-cy="update-po-number-button"
        (click)="onUpdate()"
      >
        {{ 'i18n.common.save' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
